import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { drag, DragBehavior } from 'd3-drag';
import { select } from 'd3-selection';

import { WindowViewModel } from '../../../view-models/caliper-viewmodel';
import { EcgMeasures } from '../../../models/ecgmeasures';

@Component({
    selector: '[caliper-window]',
    templateUrl: './window.component.html',
    styleUrls: ['./window.component.css'],
})
export class WindowComponent implements OnInit {

    // events

    @Output()
    removeClicked = new EventEmitter<any>();

    @Output()
    positionChange = new EventEmitter<{ x: number, y: number }>();

    // data members

    @Input()
    window!: WindowViewModel;
    @Input()
    measures!: EcgMeasures;

    // constructor

    constructor(private elementRef: ElementRef) {
    }

    // public functions

    ngOnInit() {

        const onDrag: DragBehavior<any, any, any> = drag()
            .on('start', (event) => {

                event.sourceEvent.stopPropagation();

            })
            .on('drag', (event) => {

                this.positionChange.emit({ x: event.x, y: event.y });
            });

        select(this.elementRef.nativeElement).select('#window')
            .call(onDrag);
    }

    onRemoveClick() {

        this.removeClicked.emit();
    }
}
